import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";

/**
 * Errorオブジェクト 500
 */
export class InternalServerError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, InternalServerError.prototype);
  }
}

/**
 * Errorオブジェクト 403
 */
export class ForbiddenError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}

/**
 * Errorオブジェクト 400
 */
export class BadRequestError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, BadRequestError.prototype);
  }
}

/**
 * Errorオブジェクト その他のエラー
 */
export class OtherError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, OtherError.prototype);
  }
}

export interface AuthorizeKeyResponse {
  authorizeKey: string;
  enableaccesstime: string;
  geospaceCdsRegionBlocks: GeospaceCdsRegionBlock[];
}

export interface GeospaceCdsRegionBlock {
  id: number;
  blockName: string;
  latitudeNorth: number | null;
  latitudeSouth: number | null;
  longitudeWest: number | null;
  longitudeEast: number | null;
}

/**
 * 認証キー取得APIを叩いて認証キーを取得する
 * @param apiClient
 */
export const getAuthorizeKeyAPI = async (
  apiClient: AxiosInstance
): Promise<AuthorizeKeyResponse> => {
  // 400が返る場合と
  // 402が返る場合
  // 500が返る場合がある
  const response = await apiClient
    .get<AuthorizeKeyResponse>("/geospace/authorize-key", {})
    .catch((error): void => {
      if (isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.InternalServerError) {
          throw new InternalServerError();
        } else if (error.response?.status === HttpStatusCode.Forbidden) {
          throw new ForbiddenError();
        } else if (error.response?.status === HttpStatusCode.BadRequest) {
          throw new BadRequestError();
        }
      }
      throw new OtherError();
    });
  if (response) {
    if (response.status === HttpStatusCode.Ok) {
      return response.data;
    }
  }
  throw new OtherError();
};
